import LayoutMain from '@/components/layouts/main.vue';
import { socketConnection } from '@/libs';
import { mapState } from 'vuex';
import { ACTIVE_TAB_LIMIT } from '@/constants/settings';

export default {
  name: 'Paused',
  components: {
    LayoutMain,
  },
  data() {
    return {
      isLoading: false,
      ACTIVE_TAB_LIMIT,
    };
  },
  computed: {
    ...mapState({
      lastRoute: state => state.settings.lastRoute,
      aclToken: state => state.agent.aclToken,
      isDeepLinkableDashboardActive: state => state.featureFlags.FEATURE_FLAGS.DEEP_LINKABLE_DASHBOARD,
    }),
  },
  methods: {
    activateSession() {
      this.isLoading = true;
      this.$store.dispatch('settings/setUserPausedStatus', false);
      socketConnection.setTokenAndConnect(this.aclToken);
      this.$router.push(this.lastRoute);
    },
  },
  mounted() {
    if (this.isDeepLinkableDashboardActive) {
      socketConnection.disconnect();
    } else {
      this.$router.push(this.lastRoute);
    }
  },
};
